import { useMutation, useQuery } from "react-query";
import {
    getSummary, getItemsCommissioned, getItemsPacked, getItemsShipped, getPackSize,
} from "../api-services/dashboard";
import { getPackContent } from "../../apis/api";

const clientEmails = "client";


const useGetSummary = (params = {}, options = {}) => {
    return useQuery({
        queryKey: [clientEmails, params],
        queryFn: () => getSummary(params),
        ...options,
    });
};


const useGetItemsCommissioned = (mutationOptions = {}) => {
    const mutation = useMutation({
        mutationFn: (payload) => getItemsCommissioned(payload),
        onSuccess: (data) => {
            if (mutationOptions.onSuccess) {
                mutationOptions.onSuccess(data);
            }
        },
        onError: (error) => {
            if (mutationOptions.onError) {
                mutationOptions.onError(error);
            }
        },
    });

    return {
        getItemsCommissioned: mutation.mutate,
        isLoading: mutation.isPending,
        ...mutation,
    };
};


const useGetItemsPacked = (params = {}, options = {}) => {
    return useQuery({
        queryKey: [clientEmails, params],
        queryFn: () => getItemsPacked(params),
        ...options,
    });
};


const useGetItemsShipped = (params = {}, options = {}) => {
    return useQuery({
        queryKey: [clientEmails, params],
        queryFn: () => getItemsShipped(params),
        ...options,
    });
};


const useGetPackSize = (params = {}, options = {}) => {
    return useQuery({
        queryKey: ['packSize', params],
        queryFn: () => getPackSize(params),
        ...options,
    });
};


const useGetPackContent = (params = {}, options = {}) => {
    return useQuery({
        queryKey: ['packContent', params],
        queryFn: () => getPackContent(params),
        ...options,
    });
};




export {
    useGetSummary,
    useGetItemsCommissioned,
    useGetItemsPacked,
    useGetItemsShipped,
    useGetPackSize,
    useGetPackContent
};
